import { FunctionComponent } from 'react'
import { Container, Text, Button, theme } from '@conexasaude/hero-web'
import { Icon } from '@conexasaude/icons'
import { useStyles } from './style'
import { BannerProps, IconFromVariant } from './types'
import { RenderIf } from '../RenderIf'

const Banner: FunctionComponent<BannerProps> = props => {
  const {
    variant,
    title,
    text,
    actionLabel,
    onActionClick,
    disabledAction,
    fixed,
    onClose,
  } = props
  const styles = useStyles({ variant })

  const iconFromVariant: IconFromVariant = {
    success: 'success',
    warning: 'warning',
    information: 'information',
    error: 'fail',
  }

  const colorFromVariant = {
    success: 'success',
    warning: 'warning',
    information: 'info',
    error: 'danger',
  }

  return (
    <div css={styles.root}>
      <Container>
        <div css={styles.wrapper}>
          <div css={styles.content}>
            <div css={styles.iconWrapper}>
              <Icon
                name={iconFromVariant[variant]}
                color={theme.colors?.[colorFromVariant[variant]][500]}
              />
            </div>
            <div css={styles.textWrapper}>
              <RenderIf condition={!!title}>
                <Text variant="large">
                  <strong>{title}</strong>
                </Text>
              </RenderIf>
              <Text variant="large">{text}</Text>
            </div>
          </div>
          <div css={styles.actions}>
            <Button
              variant="link"
              onClick={onActionClick}
              disabled={disabledAction}
              css={styles.actionButton}
            >
              {actionLabel}
            </Button>

            {!fixed ? (
              <button css={styles.closeButton}>
                <Icon
                  name="close"
                  color={theme.colors.extra.gray_icon}
                  onClick={onClose}
                />
              </button>
            ) : null}
          </div>
        </div>
      </Container>
    </div>
  )
}

export { Banner }
